export default __webpack_public_path__ + "static/media/road.2c238ac9.png";